import styled from 'styled-components'

export const SpacingBlank = styled.span`
    flex: 1;
`
